export default [
    "Updater",
    "HelloInt",
    "Hello"
];



// WEBPACK FOOTER //
// ./src/listProgs.js